import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

/**
 * One private folder as the caller can open it: the folder itself and the
 * items directly in it. How the bank opens a camera's folders, whose
 * contents the project's list leaves out (utils/bankCameraItems).
 */
export const getPrivateProjectBankFolderItems = async (projectId, folderId) => {
  const apiPath = `project-bank/private/project/${projectId}/private-items?parentFolderId=${encodeURIComponent(
    folderId
  )}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    // isLocalApiRequest: true,
  });

  const response = await axios(signedRequest);

  return response.data;
};
